<template>
  <div class="pt-3">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#" @click="selectClient(null)">Клиенты</a>
        </li>

        <li class="breadcrumb-item" v-if="client">
          {{ client.fullname }}
        </li>
      </ol>
    </nav>

    <Flash v-if="error" :message="error" type="danger"/>

    <Loader v-if="loading"/>

    <Item
      v-if="client"
      :client="client"/>
    <List
      v-else
      :clients="clients"
      v-on:select-client="selectClient"/>
  </div>
</template>

<script>
import Loader from './common/Loader';
import Flash from './common/Flash';
import List from './client/List';
import Item from './client/Item';

export default {
  name: 'Client',

  components: {Loader, Flash, List, Item},

  data() {
    return {
      loading: false,
      error: '',
      clientId: null,
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    clients() {
      return this.$store.state.clients;
    },

    client() {
      return this.$store.state.clients.find(
        client => client.id === this.clientId
      );
    },
  },

  methods: {
    async loadData() {
      this.loading = true;

      try {
        await this.$store.dispatch('LOAD_CLIENTS');
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    selectClient(id) {
      this.clientId = id;
    },
  },
};
</script>
